import React, { useState } from 'react';
import auth from '../../Helpers/auth'
//axios
import axios from 'axios'
//constantes
import * as Constant from '../../global/const'



const MisDatosContent = () => {

    let user = JSON.parse(auth.getUsuario());
    const [error, seterror] = useState('')
    const [errorMessage, seterrorMessage] = useState('')
    const [exitoMessage, setexitoMessage] = useState('')
    const [datosForm, setdatosForm] = useState({
        nit: user.nit,
        password: '',
        email: user.email
    })

    const onChange = e => {
        if (e.target.name === 'email') {
            var regexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
            if (!regexp.test(e.target.value)) {
                seterror('email')
            } else {
                seterror('')
            }
        }
        if (e.target.name === 'password') {
            var regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,15}$/
            if (!regexp.test(e.target.value)) {
                seterror('password')
            } else {
                seterror('')
            }
        }
        if (e.target.name === 'nit') {
            var regexp = /^[0-9,$]{5,15}$/
            if (!regexp.test(e.target.value)) {
                seterror('nit')
            } else {
                seterror('')
            }
        }
        setdatosForm({
            ...datosForm,
            [e.target.name]: e.target.value
        })
    }

    const onSubmit = () => {
        if (error !== '') {
            return
        }
        let user = JSON.parse(auth.getUsuario())
        var newObject = {
            fuente: 2,
            tipo: user.tipoClienteUsuario,
            clienteUsId: user.id,
            usuario: {
                nit: user.nit,
                codigo: user.as400,
                agencia: user.bodega
            },
            credenciales: {
                email: datosForm.email,
                emailValidate: datosForm.email,
                password: datosForm.password,
                passwordValidate: datosForm.password
            }
        }
        axios.post(Constant.UPDATEDATOS, newObject).then((response) => {
            seterrorMessage('')
            setexitoMessage(response.data.message)
        }).catch((err) => {
            setexitoMessage('')
            if (err.response.data.errors) {
                var objkeys = Object.keys(err.response.data.errors)
                seterrorMessage(err.response.data.errors[objkeys[0]][0]);
            } else {
                seterrorMessage(err.response.data.error);
            }
        })
    }


    return (
        <div className="content-Misdatos">
            <div className="headerDatos">
                <h1>Mis datos</h1>
                <p>Estos son los datos correspondientes al usuario administrador de la página, aquí podrás editar tu correo y contraseña para iniciar sesión.</p>
            </div>
            <div className="datosPersonales">
                <div className="left-datos">
                    <h1>Datos personales</h1>
                    {/* <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero, laborum </p> */}
                </div>
                <div className="rigth-datos">
                    {errorMessage !== '' ? <span className="error">{errorMessage}</span> : null}{exitoMessage !== '' ? <span className="exito">{exitoMessage}</span> : null}
                    <form className="formulario" action="">
                        <div className="campo">
                            <label htmlFor="">NIT / Documento</label>
                            <input name="nit" type="text" onChange={onChange} value={datosForm.nit} readOnly={true} />
                            {error === 'nit' ? <span className="error">Formato de Nit incorrecto</span> : null}
                        </div>
                        <div className="juntos">
                            <div className="campo">
                                <label htmlFor="">Correo electrónico</label>
                                <input name="email" type="text" onChange={onChange} value={datosForm.email} readOnly={true} />
                                {error === 'email' ? <span className="error">Formato de Email invalido</span> : null}
                            </div>
                            <div className="campo">
                                <label htmlFor="">Contraseña</label>
                                <input name="password" type="password" placeholder="******" onChange={onChange} value={datosForm.password} readOnly={true} />
                                {error === 'password' ? <span className="error">La contraseña debe tener una Mayuscula y un caracter especial @</span> : null}
                            </div>
                        </div>
                        {/* <div className="btn-datos-content">
                            <div
                                className="btn-datos no-seleccionable avoid-click"
                                onClick={
                                    () => {
                                        // onSubmit()
                                    }
                                }
                            >
                                <h4>Editar</h4>
                            </div>
                        </div> */}
                    </form>
                </div>
            </div>
            {/*  <div className="bottom-datos">
            <h1>Si deseas crear un nuevo punto de venta</h1>
            <div className="btn-datos no-seleccionable">
                <h4>Crear punto de Venta</h4>
            </div>
        </div> */}
        </div>
    )
}
export default MisDatosContent;